import { useEffect, useState } from "react"
import { ColumnDef } from "@tanstack/react-table"
import { getAttractedUsers, IAttractedUser } from "@/shared/api/users"
import { toLocaleDateTimeString } from "@/shared/lib/date-formatters"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { Pagination } from "@/shared/ui/pagination"
import { Table } from "@/shared/ui/table"
import { PageHeader } from "@/widgets/page-header"

const limit = 50

export const UsersAttractedPage = () => {
    const [items, setItems] = useState<IAttractedUser[]>([])
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const [totalCount, setTotalCount] = useState(0)
    const [isLoading, setIsLoading] = useState(true)

    const columns: ColumnDef<IAttractedUser, any>[] = [
        {
            accessorFn: (item) => (
                <div className="text-nowrap">
                    {toLocaleDateTimeString(item.attracted_at)}
                </div>
            ),
            id: 'attracted_at',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Момент привязки</div>,
        },
        {
            accessorFn: (item) => (
                <div className="flex flex-col gap-[2px]">
                    <div>{item.user_name || "нет данных"}</div>
                    <div className="text-[13px] text-[#828282]">{item.telegram_id || "—"}</div>
                </div>
            ),
            id: 'user',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Данные пользователя</div>,
        },
        {
            accessorFn: (item) => (
                <div className="flex flex-col gap-[2px] max-w-[360px]">
                    <div className="font-semibold">{item.utm_slug || "—"}</div>
                    <div>{item.utm_name || "—"}</div>
                    <div className="text-[13px] text-[#828282] whitespace-normal">{item.utm_description || "—"}</div>
                </div>
            ),
            id: 'utm',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Данные UTM</div>,
        },
        {
            accessorFn: (item) => (
                <div>
                    {item.application_name || "—"}
                </div>
            ),
            id: 'application_name',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Приложение</div>,
        },
    ]

    useEffect(() => {
        const load = async () => {
            setIsLoading(true)
            try {
                const response = await getAttractedUsers({ page, limit })
                setItems(response.data.items)
                setTotalPages(response.data.totalPages)
                setTotalCount(response.data.totalCount)
            } catch (error) {
                setItems([])
                setTotalPages(0)
                setTotalCount(0)
                console.error('Error loading attracted users:', error)
            } finally {
                setIsLoading(false)
            }
        }

        load()
    }, [page])

    return (
        <div className="_page_container">
            <PageHeader title="пользователи" />
            <div className="flexbox">
                <PageSubtitle title="Привлечение пользователей по ссылке" />
                {Boolean(items.length) &&
                    <div className="table_box">
                        <Table columns={columns} data={items} />
                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            totalCount={totalCount}
                            setPage={setPage}
                        />
                    </div>
                }
                {(!Boolean(items.length) && isLoading) &&
                    <div className="info_panel">
                        <Loader />
                    </div>
                }
                {(!Boolean(items.length) && !isLoading) &&
                    <NoTableData label="Нет данных о привлечении пользователей по ссылке" />
                }
            </div>
        </div>
    )
}
